import { useContext, useEffect } from 'react';

import { compact } from 'lodash';

import { useSalesForceInApp } from 'hooks/use-salesforce-in-app';
import { LocationContext } from 'state/location';
import {
  CustomEventNames,
  EventTypes,
  MParticleContext,
  useMParticleContext,
} from 'state/mParticle';
import { setUserUTMAttributes } from 'state/mParticle/set-user-attributes';
import { useStoreContext } from 'state/store';
import { routes } from 'utils/routing';

import { useFeatureHomePage } from '../features/home-page/use-feature-home-page';

export default function useLogPageView() {
  const locationContext = useContext(LocationContext);
  const { pathname } = locationContext.location;
  const { search } = locationContext.location;
  const mParticle = useContext(MParticleContext);
  const { homePageId } = useFeatureHomePage();
  const { trackEvent } = useMParticleContext();
  const { store } = useStoreContext();

  const { handleLogPageView } = useSalesForceInApp();

  useEffect(() => {
    // get mParticle user object with current attributes
    const user = window.mParticle?.Identity?.getCurrentUser?.();

    // add the UTM attributes conteined on URL to mParticle user object
    setUserUTMAttributes(user, new URLSearchParams(window.location.search));

    const addr = store.physicalAddress;
    const restaurantData = {
      restaurantNumber: store.number || '',
      restauranteName: store.name || '',
      restaurantCity: addr?.city || '',
      restaurantCountry: addr?.country || '',
      restaurantPOS: store.pos?.vendor ?? '',
    };
    // determine attributes to send to the events below
    const attrs = {
      pathname,
      pathWithQuery: pathname + search,
      sanityId: pathname === routes.base ? homePageId.featureHomePageId : '',
      referrer: window.location.toString() || document.referrer,
      ...restaurantData,
    };
    const restaurantAddress = {
      restaurantId: store._id || '',
      restaurantAddress: compact([addr?.address1, addr?.address2]).join(', ') || '',
      restaurantZip: addr?.postalCode || '',
      restaurantCity: addr?.city || '',
      restaurantState: addr?.stateProvince || '',
      restaurantCountry: addr?.country || '',
    };
    // Flags for google analytics integration
    const flags = {
      'Google.Page': pathname,
      'Google.DocumentReferrer': window.location.toString() || document.referrer,
    };
    // mParticle page view event - uses mParticle logPageView API to track page view
    mParticle.logPageView(pathname, attrs, flags);
    // mParticle custom event for page view - uses mParticle logEvent API to track page view
    trackEvent({
      name: CustomEventNames.PAGE_VIEW,
      type: EventTypes.Other,
      attributes: {
        ...attrs,
        ...flags,
        path: pathname,
        ...restaurantAddress,
        pathWithQuery: pathname,
      },
    });

    handleLogPageView();
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps
}
